export type Environment = 'dev' | 'prod';

export interface EnvironmentConfig {
  name: string;
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  razorpay: {
    keyId: string;
    keySecret: string;
  };
}

export const environments: Record<Environment, EnvironmentConfig> = {
  dev: {
    name: 'Development',
    firebase: {
      apiKey: 'AIzaSyBHVLNjy0yZ_djnWfxxeNeqNL7F7ZawRuQ',
      authDomain: 'tutor-dev-cf102.firebaseapp.com',
      projectId: 'tutor-dev-cf102',
      storageBucket: 'tutor-dev-cf102.firebasestorage.app',
      messagingSenderId: '431110403274',
      appId: '1:431110403274:web:dev',
    },
    razorpay: {
      keyId: 'rzp_test_RpoMeGUNAiwRsc',
      keySecret: '7bz4qVTOVVQYuGUpOsxjzSxE',
    },
  },
  prod: {
    name: 'Production',
    firebase: {
      apiKey: 'AIzaSyDo7ABRZe2Z7AM0UKIHdwswVv6NpKiDA_Y',
      authDomain: 'tutor-4dce7.firebaseapp.com',
      projectId: 'tutor-4dce7',
      storageBucket: 'tutor-4dce7.firebasestorage.app',
      messagingSenderId: '612084019722',
      appId: '1:612084019722:web:4f3e0154636bec097d65f3',
    },
    razorpay: {
      keyId: '', // Add production Razorpay key if available
      keySecret: '', // Add production Razorpay secret if available
    },
  },
};

export const environmentService = {
  getCurrentEnvironment: (): Environment => {
    const env = process.env.REACT_APP_ENVIRONMENT;
    if (env === 'prod' || env === 'dev') {
      return env;
    }
    // Default to dev in development mode, or if not specified
    return 'dev';
  },

  getConfig: (): EnvironmentConfig => {
    const env = environmentService.getCurrentEnvironment();
    return environments[env];
  },
};






